import React from 'react';
import {string} from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    width: auto;
    height: auto;
    margin: 10px auto;
`;

const Image = styled.img`
    display:block;
    border-radius: 4px;
    width: 400px;
    height: auto;
    object-fit: cover;
`;

const RitImageBlock = ({ src }) => (
    <Container>
        <Image src={src}/>
    </Container>
);

RitImageBlock.propTypes = {
    src: string.isRequired,
}

export default RitImageBlock;